class ResiliaTheme {
  constructor() {
    this.boundClick = this.onClick.bind(this);
    this.boundKeydown = this.onKeydown.bind(this);
    this.drawerCloseStates = new WeakMap();
    document.addEventListener('click', this.boundClick);
    document.addEventListener('keydown', this.boundKeydown);
    document.addEventListener('cart:updated', (event) => this.updateCartCount(event.detail));
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
  }

  onClick(event) {
    const openControl = event.target.closest('[data-dialog-open]');
    if (openControl) {
      const dialog = document.getElementById(openControl.dataset.dialogOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closeControl = event.target.closest('[data-dialog-close]');
    if (closeControl) {
      const dialog = closeControl.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    const drawerControl = event.target.closest('[data-drawer-toggle]');
    if (drawerControl) {
      this.toggleDrawer(drawerControl.dataset.drawerToggle, drawerControl);
      return;
    }

    const drawerClose = event.target.closest('[data-drawer-close]');
    if (drawerClose) this.closeDrawer(drawerClose.closest('[data-drawer]'));
  }

  onKeydown(event) {
    const openDrawer = document.querySelector('[data-drawer][data-open="true"]');
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-drawer][data-open="true"]').forEach((drawer) => this.closeDrawer(drawer));
      const dialog = document.querySelector('dialog[open]');
      if (dialog) dialog.close();
      return;
    }

    if (event.key !== 'Tab' || !openDrawer) return;
    const panel = openDrawer.querySelector('.menu-drawer__panel');
    const focusable = panel
      ? [...panel.querySelectorAll('button, a[href], input, select, textarea, [contenteditable="true"], [tabindex]:not([tabindex="-1"])')]
        .filter((element) => !element.disabled && element.tabIndex !== -1 && element.offsetParent !== null)
      : [];
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!panel.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  toggleDrawer(id, control) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    const shouldOpen = drawer.dataset.open !== 'true';
    if (shouldOpen) {
      this.cancelDrawerClose(drawer);
      const wasHidden = drawer.hasAttribute('hidden');
      drawer.removeAttribute('hidden');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      if (wasHidden) drawer.getBoundingClientRect();
      drawer.dataset.open = 'true';
      control.setAttribute('aria-expanded', 'true');
      document.body.classList.add('no-scroll');
      const focusTarget = drawer.querySelector('.menu-drawer__panel button, .menu-drawer__panel a, .menu-drawer__panel input, .menu-drawer__panel select, .menu-drawer__panel textarea, .menu-drawer__panel [tabindex]:not([tabindex="-1"])');
      if (focusTarget) focusTarget.focus();
    } else {
      this.closeDrawer(drawer);
    }
  }

  closeDrawer(drawer) {
    if (!drawer) return;
    this.cancelDrawerClose(drawer);
    const control = document.querySelector(`[data-drawer-toggle="${drawer.id}"]`);
    if (control) {
      control.setAttribute('aria-expanded', 'false');
      control.focus();
    }
    drawer.dataset.open = 'false';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (!document.querySelector('[data-drawer][data-open="true"]')) {
      document.body.classList.remove('no-scroll');
    }

    const panel = drawer.querySelector('.menu-drawer__panel');
    if (!panel || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.finishDrawerClose(drawer);
      return;
    }

    const onTransitionEnd = (event) => {
      if (event.target === panel && event.propertyName === 'transform') this.finishDrawerClose(drawer);
    };
    panel.addEventListener('transitionend', onTransitionEnd);
    const timer = window.setTimeout(() => this.finishDrawerClose(drawer), 360);
    this.drawerCloseStates.set(drawer, { panel, onTransitionEnd, timer });
  }

  cancelDrawerClose(drawer) {
    const state = this.drawerCloseStates.get(drawer);
    if (!state) return;
    state.panel.removeEventListener('transitionend', state.onTransitionEnd);
    window.clearTimeout(state.timer);
    this.drawerCloseStates.delete(drawer);
  }

  finishDrawerClose(drawer) {
    this.cancelDrawerClose(drawer);
    if (drawer.dataset.open === 'false') drawer.setAttribute('hidden', '');
  }

  updateCartCount(detail) {
    const directCount = detail && typeof detail.item_count === 'number' ? detail.item_count : null;
    const nestedCount = detail && detail.cart && typeof detail.cart.item_count === 'number' ? detail.cart.item_count : null;
    const count = directCount ?? nestedCount;
    if (count === null) return;
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
      element.toggleAttribute('hidden', count === 0);
    });
  }
}

if (!window.resiliaTheme) window.resiliaTheme = new ResiliaTheme();
